export const internalURLs = {
  PrinterOverviewURL: '/hp-all-in-print-plan/overview'
};
